// src/utils/tourConstants.ts
export const TOUR_STEPS = {
  START: 1,
  BLANK_CAMPAIGN: 2,
  CREATE: 3,


  TITLE: 11,
  TYPE: 12,
  STATUS: 13,

  TARGET_TYPE: 14,
  TARGET_IDS: 15,
  EXCLUDE_CHECK: 16,
 
  SCHED_TYPE: 17,
  SCHED_VALUE: 18,

  QTY_RANGE: 20,
  QTY_VALUE: 21,
  QTY_TOGGLE: 22,
  QTY_ADD_BTN: 23,

  EB_QUANTITY: 30,
  EB_VALUE: 31,
  EB_TOGGLE: 32,
  EB_ADD_BTN: 33,

  BOGO_BUY: 40,
  BOGO_GET: 41,

  EXCLUDE_SALE: 60,
  USAGE_TOGGLE: 61,
  USAGE_INPUT: 62,
  SCHED_TOGGLE: 63,
  START_TIME: 64,
  END_TIME: 65,

  DISPLAY_SECTION: 70,

  SAVE_BTN: 80,
};
